<div class="row g-0 box--one">
  <div
    class="col-auto"
    *ngFor="let it of list"
    [ngClass]="boxClass(it)"
    (click)="select(it)"
  >
    <div [ngClass]="textClass(it)">{{ categoryName(it) }}</div>
  </div>
</div>
